import { mods } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const OpacityWrapper = styled.div<StyledMods<{ shouldApplyOpacity?: boolean }>>`
    ${mods('shouldApplyOpacity', true)`
        opacity: 0.5;
    `};
`;
